import { render, staticRenderFns } from "./cell-switch.vue?vue&type=template&id=899eb2b4&scoped=true"
import script from "./cell-switch.ts?vue&type=script&lang=ts&external"
export * from "./cell-switch.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899eb2b4",
  null
  
)

export default component.exports